import { Box, Icon, Tooltip } from '@material-ui/core';
import React from 'react';
import { useStyles } from './styles';

interface IProps {
  participants?: number;
  style: 'primary' | 'secondary' | 'stacked';
}

function CounterIcon({ participants, style }: IProps) {
  const classes = useStyles();

  return (
    <Tooltip
      title="Current viewers"
      placement="bottom"
      classes={{ tooltip: classes.toolTip }}
    >
      <Box className={classes[style]}>
        <Icon className={classes[`${style}__icon`]}>visibility</Icon>
        {'number' === typeof participants && participants > 0 && participants}
      </Box>
    </Tooltip>
  );
}

export { CounterIcon };
